/* eslint-disable monorepo/no-internal-import */
// eslint-disable-next-line monorepo/no-internal-import
import {lazy} from '@aboutyou/lazy-imports';
import {
  ActivateAaMigrationGeneralTest,
  CouponTopBanner,
  DiscountBanner,
  DiscountsRefresh,
  FooterLayout,
  useFullScreenView,
} from '@aboutyou/logic-components';
import {AdBlockDetection} from '@aboutyou/logic-components/src/client-services/AdBlockDetection/AdBlockDetection';
import {DisableAddToHomeScreen} from '@aboutyou/logic-components/src/client-services/DisableAddToHomeScreen/DisableAddToHomeScreen';
import {RegisterDataFetcherSideEffects} from '@aboutyou/logic-components/src/features/RegisterDataFetcherSideEffects/RegisterDataFetcherSideEffects';
import {useIsCheckoutPage} from '@aboutyou/router';
import {
  ClientGate,
  ErrorBoundary,
  SkipToContentLink,
} from '@aboutyou/ui-components';
import React from 'react';
import {AppProviders} from './AppProviders';
import {RouteComponents} from './RouteComponents';
import {FooterDynamic} from './components/globals/Footer/FooterDynamic';
import {FooterDynamicADP} from './components/globals/Footer/FooterDynamicADP';
import {FooterStatic} from './components/globals/Footer/FooterStatic';
import {Header} from './components/globals/Header/Header';
import {ConditionalUspBanner} from './components/globals/UspBanner/ConditionalUspBanner';

const LazyClientComponents = lazy(() =>
  import('./ClientComponents').then(mod => ({
    default: mod.ClientComponents,
  })),
);

export const App: React.FC<{}> = () => {
  return (
    <AppProviders>
      <ActivateAaMigrationGeneralTest />
      <DisableAddToHomeScreen />
      <SkipToContentLink />
      <DiscountsRefresh />
      <RegisterDataFetcherSideEffects />

      <ErrorBoundary renderContext="header_coupon_banner">
        <ConditionalCouponTopBanner />
      </ErrorBoundary>
      <ErrorBoundary renderContext="header_campaign_banner">
        <ConditionalDiscountBanner />
      </ErrorBoundary>

      <ConditionalHeader />
      <ConditionalUspBanner />
      <ErrorBoundary renderContext="route_components">
        <RouteComponents />
      </ErrorBoundary>
      <ConditionalFooter />

      <ErrorBoundary renderContext="ad_block_detection" ErrorComponent={null}>
        <AdBlockDetection />
      </ErrorBoundary>

      <ClientGate>
        <LazyClientComponents />
      </ClientGate>
    </AppProviders>
  );
};

const ConditionalHeader = () => {
  const {isHeaderDisabled} = useFullScreenView();
  if (isHeaderDisabled) {
    return null;
  }
  return (
    <ErrorBoundary renderContext="header">
      <Header />
    </ErrorBoundary>
  );
};

const ConditionalCouponTopBanner = () => {
  const isCheckoutPage = useIsCheckoutPage();
  if (isCheckoutPage) {
    return null;
  }
  return <CouponTopBanner />;
};

const ConditionalFooter = () => {
  const {isFooterDisabled} = useFullScreenView();
  if (isFooterDisabled) {
    return null;
  }
  return (
    <ErrorBoundary renderContext="footer">
      <FooterDynamic />
      <FooterDynamicADP />
      <FooterLayout>
        <FooterStatic />
      </FooterLayout>
    </ErrorBoundary>
  );
};

const ConditionalDiscountBanner = () => {
  const isCheckoutPage = useIsCheckoutPage();
  if (isCheckoutPage) {
    return null;
  }
  return <DiscountBanner />;
};
